import * as React from 'react';
import { ReactComponent as EyeSlashIconSVG } from '../../assets/icons/mevo/ic_eye_slash.svg';
import IconPattern, { IconProps } from './_IconPattern';

const EyeSlashIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={EyeSlashIconSVG} variantPlaces={[2, 3, 4]} {...props} />;
};

export default EyeSlashIcon;
